/**
 * Create vue basic plugin
 * @param {string} name
 * @param {object} currentModule
 */
export const makeVueBasicPlugin = (name, currentModule) => ({
    // The install method will be called with the Vue constructor as the first argument, along with possible options
    install(Vue, options) {
        // Add $surname instance property directly to Vue components
        Vue.prototype[name] = currentModule
    }
})